interface League {
  slug: string
  displayName: string
  category: string
}

interface FilterBarProps {
  leagues: League[]
  selected: string
  onSelect: (slug: string) => void
}

const filterStyles = `
  .odds-filter-btn {
    border-color: #C8E2FF;
  }
  .odds-filter-btn:hover {
    border-color: #0db5ff;
  }
  .odds-filter-btn[data-active="true"] {
    border-color: #0db5ff;
    background: #F3F9FF;
    box-shadow: 0 1px 4px rgba(13,181,255,0.15);
  }
  .dark .odds-filter-btn {
    border-color: var(--ow-border);
  }
  .dark .odds-filter-btn:hover {
    border-color: var(--ow-accent);
  }
  .dark .odds-filter-btn[data-active="true"] {
    border-color: var(--ow-accent);
    background: var(--ow-accent-soft);
    color: var(--ow-ink);
    box-shadow: none;
  }
`

function FilterBar({ leagues, selected, onSelect }: FilterBarProps) {
  return (
    <div>
      <style>{filterStyles}</style>
      <h3 className="text-lg font-semibold text-gray-900 mb-2.5 dark:text-(--ow-ink)">
        Leagues:
      </h3>
      <div className="flex gap-2 overflow-x-auto pb-1" style={{ scrollbarWidth: 'none' }}>
        {leagues.map(league => (
          <button
            key={league.slug}
            type="button"
            className="odds-filter-btn px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-150 border-2 bg-white text-gray-900 dark:bg-(--ow-inset) dark:text-(--ow-ink-2)"
            data-active={selected === league.slug}
            onClick={() => onSelect(league.slug)}
          >
            {league.displayName}
          </button>
        ))}
      </div>
    </div>
  )
}

export default FilterBar
